<app-multimedia-choose-or-upload-multiple
  (chooseClickEvent)="handleChooseClickEvent($event)"
  (clearClickEvent)="handleClearClickEvent($event)"
  [allowedMimeTypes]="allowedMimeTypes"
  [allowedMultimediaTypes]="allowedMultimediaTypes"
  [disabled]="disabled()"
  [maxFileSize]="maxFileSize"
  [multimediaIds]="multimediaIds()" />
